import axios from 'axios';
import {
    ADD_EGALLERY,
    CLEAR_EGALLERY,
    GET_EGALLERY,
    GET_EGALLERY_BY_ID,
    UPDATE_EGALLERY,
    CLEAR_UPDATE_EGALLERY
} from '../types';
import { EGALLERY_SERVER } from '../misc';

export function addGallery(dataToSubmit) {
    // console.log(dataToSubmit, "<<<<<<<<data to submit from form")
    const formData = new FormData();
    for (const key in dataToSubmit) {
        if ((dataToSubmit[key])) {
            if (key === 'images') {
                dataToSubmit[key].forEach((img, i) => {
                    formData.append(`image${i}`, img);
                });
            } else {
                formData.append(key, dataToSubmit[key]);
            }
        }
    }

    // console.log(formData, "<<<<<<<<formDataformDataformDataformData")
    const request = axios.post(`${EGALLERY_SERVER}/addgallery`, formData)
        .then(response => response.data);

    return {
        type: ADD_EGALLERY,
        payload: request
    }
}

export function clearGallery() {
    return {
        type: CLEAR_EGALLERY,
        payload: ''
    }
}

export function updateGallery(dataToSubmit, id) {
    const formData = new FormData();
    for (const key in dataToSubmit) {
        if ((dataToSubmit[key])) {
            if (key === 'imagesToAdd') {
                dataToSubmit[key].forEach((img, i) => {
                    formData.append(`image${i}`, img);
                });
            } else {
                formData.append(key, dataToSubmit[key]);
            }
        }
    }

    const request = axios.post(`${EGALLERY_SERVER}/updategallery?id=${id}`, formData)
        .then(response => response.data);

    return {
        type: UPDATE_EGALLERY,
        payload: request
    }
}

export function clearUpdateGallery() {
    return {
        type: CLEAR_UPDATE_EGALLERY,
        payload: ''
    }
}

export function getEGallery() {
    const request = axios.get(`${EGALLERY_SERVER}/getgallery`)
        .then(response => response.data);

    return {
        type: GET_EGALLERY,
        payload: request
    }
}

export function getGalleryByid(id){
    const request = axios.get(`${EGALLERY_SERVER}/getgallerybyid?id=${id}&type=single`)
    .then(response => response.data);

    return {
        type: GET_EGALLERY_BY_ID,
        payload: request
    }
}